import React from 'react';
import { useFormikContext } from 'formik';
import { SimpleButton } from '../..';

type Props = {
  updatePhoneTitle: boolean;
  onClick: () => void;
  disabled?: boolean;
};

const OpenSetupPhoneButton = ({ onClick, updatePhoneTitle, disabled = false }: Props) => {
  const { dirty } = useFormikContext();

  return (
    <SimpleButton
      onClick={onClick}
      disabled={disabled || dirty}
      disableRipple
    >
      { updatePhoneTitle ? 'Change phone number' : 'Set up mobile notifications' }
    </SimpleButton>
  );
};

export default OpenSetupPhoneButton;
